import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Copyleft: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['circle', { cx: '12', cy: '12', r: '10' }],
    ['path', { d: 'M9.17 14.83a4 4 0 1 0 0-5.66' }],
  ],
];

export default Copyleft;
